import React from "react";

const Body = (props) => {
    const {
        canCreateBids,
        autoSetMainContract,
        displayLateAndIdleTimeInReport,
        allowUnloadPointAdjustmentUsage,
        bidRecalculationOffsetHours,
        maxFileSizeInMb,
        noAccessToEditBooks,
        hasCompoundCargos,
        usesDriverManualBidCompletion,
        analyzeOverallReportByHourlyMileage,
        adminHasAccessToDriverPasswords,
        isDocumentReceivingMandatory,
        useCargorunRouterOnly,
        adminCanDownloadDriverList,
        parallelItemChangePoints,
        trackEmptyMileageBidTypes,
        useOdometerMileage,
        useTrailerMileage,
        updateStartedByWhenCarChanged,
        allowEditingCompletedBidsForEnterprise,
        forceCompleteOnLastPointManualDates,
        hasAccessToEditCars,
        hasAccessToEditDrivers,
        hasAccessToEditTrailers,
        hasAccessToEditCounterparties,
        hasAccessToEditLegalPersons,
        headLogistCanEditCompletedBids,
        limitedFunctionality,
        suitableOrders,
        prohibitionOfRevertingBidForHeadLogist,
        prohibitionOfStartingBidIfEmptyStarted,
        tileTypes,
        hiddenDirection,
        businessPartner,
        prohibitionOfBidDelete,
        skipBlockIfUnpaid,
        useRefuelingTransactions,
        renderRelayIds,
        renderRelay,
        renderField,
        renderSelect,
        renderCheckbox,
        renderCatalogs,
        renderExtendedProperties,
        renderNormalizeCarNumbers,
        changeFieldsOrderBtn,
        renderCode,
        renderAtiSuExternalId,
        values,
        setValue,
        Button,
    } = props;

    const businessPartnerValues = values.businessPartner || {};
    const businessPartnerDefaultValues = {
        daysBeforeBlockForNotification: businessPartner.config.daysBeforeBlockForNotification.value,
    };
    const onBusinessPartnerChange = ({ name, value }) =>
        setValue({
            name: "businessPartner",
            value: { ...businessPartnerDefaultValues, ...businessPartnerValues, [name]: value },
        });

    return (
        <div className="row">
            <div className="col-12">
                <h5>Ответственный за платежи</h5>
                {renderField({
                    ...businessPartner.config.fullName,
                    value: businessPartnerValues.fullName ?? "",
                    onChange: onBusinessPartnerChange,
                })}
                {renderField({
                    ...businessPartner.config.phoneNumber,
                    value: businessPartnerValues.phoneNumber ?? "",
                    onChange: onBusinessPartnerChange,
                })}
                {renderField({
                    ...businessPartner.config.email,
                    value: businessPartnerValues.email ?? "",
                    onChange: onBusinessPartnerChange,
                })}
                {renderField({
                    ...businessPartner.config.daysBeforeBlockForNotification,
                    value:
                        businessPartnerValues.daysBeforeBlockForNotification ??
                        businessPartner.config.daysBeforeBlockForNotification.value,
                    onChange: onBusinessPartnerChange,
                })}
                {renderCheckbox({
                    ...businessPartner.config.shouldNotifyAboutSubscriptionExpirationEmail,
                    value: businessPartnerValues.shouldNotifyAboutSubscriptionExpirationEmail ?? false,
                    onChange: onBusinessPartnerChange,
                })}
                {renderCheckbox({
                    ...businessPartner.config.shouldNotifyAboutSubscriptionExpirationSms,
                    value: businessPartnerValues.shouldNotifyAboutSubscriptionExpirationSms ?? false,
                    onChange: onBusinessPartnerChange,
                })}
                <h5>Настройки</h5>
                {renderField(bidRecalculationOffsetHours)}
                {renderField(maxFileSizeInMb)}
                {renderSelect(tileTypes)}
                {renderCode()}
                {renderAtiSuExternalId && renderAtiSuExternalId()}
                {renderRelayIds()}
                {renderRelay()}
                {renderNormalizeCarNumbers()}
                <h5>Флаги</h5>
                {renderCheckbox(canCreateBids)}
                {renderCheckbox(noAccessToEditBooks)}
                {renderCheckbox(hasCompoundCargos)}
                {renderCheckbox(usesDriverManualBidCompletion)}
                {renderCheckbox(analyzeOverallReportByHourlyMileage)}
                {renderCheckbox(adminHasAccessToDriverPasswords)}
                {renderCheckbox(useCargorunRouterOnly)}
                {renderCheckbox(adminCanDownloadDriverList)}
                {renderCheckbox(parallelItemChangePoints)}
                {renderCheckbox(isDocumentReceivingMandatory)}
                {renderCheckbox(autoSetMainContract)}
                {renderCheckbox(displayLateAndIdleTimeInReport)}
                {renderCheckbox(allowUnloadPointAdjustmentUsage)}
                {renderCheckbox(headLogistCanEditCompletedBids)}
                {renderCheckbox(prohibitionOfStartingBidIfEmptyStarted)}
                {renderCheckbox(limitedFunctionality)}
                {renderCheckbox(suitableOrders)}
                {renderCheckbox(prohibitionOfRevertingBidForHeadLogist)}
                {renderCheckbox(trackEmptyMileageBidTypes)}
                {renderCheckbox(hiddenDirection)}
                {renderCheckbox(prohibitionOfBidDelete)}
                {renderCheckbox(skipBlockIfUnpaid)}
                {renderCheckbox(useOdometerMileage)}
                {renderCheckbox(useTrailerMileage)}
                {renderCheckbox(updateStartedByWhenCarChanged)}
                {renderCheckbox(allowEditingCompletedBidsForEnterprise)}
                {renderCheckbox(useRefuelingTransactions)}
                {renderCheckbox(forceCompleteOnLastPointManualDates)}
            </div>
            <div className="col-12 pb-4">
                <h5>Доступ к редактированию справочников</h5>
                {renderCheckbox(hasAccessToEditCars)}
                {renderCheckbox(hasAccessToEditDrivers)}
                {renderCheckbox(hasAccessToEditTrailers)}
                {renderCheckbox(hasAccessToEditCounterparties)}
                {renderCheckbox(hasAccessToEditLegalPersons)}
            </div>
            <div className="col-12 pb-4">
                <h5 className="d-flex justify-content-between">
                    <span>Справочники</span> {changeFieldsOrderBtn}
                </h5>
                {renderCatalogs()}
                <h5 className="d-flex justify-content-between">
                    <span>Кастомные поля</span> {changeFieldsOrderBtn}
                </h5>
                {renderExtendedProperties()}
                {!!Button && <Button />}
            </div>
        </div>
    );
};

export default Body;
